import { render } from "./Column202310.vue?vue&type=template&id=3561d8c5&scoped=true"
import script from "./Column202310.vue?vue&type=script&lang=js"
export * from "./Column202310.vue?vue&type=script&lang=js"

import "./Column202310.vue?vue&type=style&index=0&id=3561d8c5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3561d8c5"

export default script